// extracted by mini-css-extract-plugin
export default {"container":"bonus-module__container__qdjF7","logo":"bonus-module__logo__MUxk-","bonus":"bonus-module__bonus__ZZTW7","details":"bonus-module__details__PTo6t"};